import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from '@shopify/polaris';
import { AlertBubbleIcon } from '@shopify/polaris-icons';

import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

const CustomerIssuesSidebar = () => {
  const location = useLocation();
  const { user } = useContext(AuthenticationContext);

  const isAdminUser = user?.modules?.some((module) => module.value === 'customer_issues' && parseInt(module.tier) > 2);

  const subNavigationItems = [
    {
      url: '/customer_issues/search',
      disabled: false,
      label: 'All Issues',
    },
  ];

  if (isAdminUser) {
    subNavigationItems.push({
      url: '/customer_issues/servman_sql_logs',
      disabled: false,
      label: 'Servman Logs',
    });
  }

  const navigationItems = [
    {
      label: 'Customer Issues',
      url: '/customer_issues/search',
      icon: AlertBubbleIcon as any,
      matches: true,
      subNavigationItems,
    },
  ];

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={navigationItems} />
    </Navigation>
  );
};

export default CustomerIssuesSidebar;
